import type { EventLogFromSocket } from 'src/types/requests/eventslog/events_log';

interface EventLogStructure {
	result?: Record<string, EventLogFromSocket[]>;
}

class EventLogStore {
	private _deviceId: string | number | null = null;
	private _channel: string | number | null = null;
	private _events: EventLogStructure = {};
	private _subscribers: ((events: EventLogStructure) => void)[] = [];

	get channel(): string | number | null {
		return this._channel;
	}

	set channel(channel: string) {
		this._channel = channel;
	}

	get deviceId(): string | number | null {
		return this._deviceId;
	}

	set deviceId(id: string) {
		this._deviceId = id.replace(/_.*/, '');
	}

	get events(): EventLogStructure {
		return this._events;
	}

	clear(): void {
		this._deviceId = null;
		this._events = {};
		this.notifySubscribers();
	}

	addEvent(event: EventLogFromSocket): void {
		// A dirty way to convert the event timestamp to milliseconds
		// This is a temporary fix until we can get the correct timestamp from the server.
		// event.t = event.t * 1000;
		// event.p - taking deviceid, channel and event result
		// event.e = type of event, refer for more in src/services/socket_events.ts
		// tag - deviceId (adding it, since we lack in in the original package from the server)

		let reformeddEvent = {
			...event,
			t: event.t,
			p: JSON.stringify(event.p),
			tag: this._deviceId,
		};

		if (this._deviceId != event.p[0] || (this._channel && this._channel != event.p[1])) {
			return;
		} else {
			this._events.result = this._events.result || {};
			this._events.result[this._deviceId] = [
				...(this._events.result[this._deviceId] || []),
				reformeddEvent,
			];
			this.notifySubscribers();
		}
	}

	subscribe(callback: (events: EventLogStructure) => void): () => void {
		if (!this._subscribers) {
			this._subscribers = [];
		}
		this._subscribers.push(callback);
		callback(this._events);
		return () => {
			this._subscribers = this._subscribers.filter((sub) => sub !== callback);
		};
	}

	private notifySubscribers(): void {
		for (const sub of this._subscribers) {
			sub(this._events);
		}
	}

	getAllEvents(callback: (events: EventLogStructure) => void): () => void {
		return this.subscribe(callback);
	}
}

export const eventLogStore = new EventLogStore();
